import type { GridColumn } from "@/types";
import type { GridColumnOption } from "@stores/survey/grids/gridRows";

export type GridTableColumn = GridColumn & { option?: GridColumnOption };

export const columnKey = (column: GridColumn) => `col-${column.id ?? `question-${column.question_id}`}`;

export const SEPARATED = { class: "border-l border-secondary", headerClass: "border-l border-secondary" };

export const quotesLabel = (count: number) => `${count} ${count === 1 ? "quote" : "quotes"}`;
